import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '.';

export const selectAdminSlice = state => state.admin || initialState;

export const selectAdmin = createSelector([selectAdminSlice], state => state);

export const selectIsAdminAuth = createSelector(
  [selectAdminSlice],
  state => state.isAdminAuthorized,
);
